import { WORKFLOWS } from "./data";
import { Reveal, Eyebrow } from "./Primitives";

export const Workflows = () => (
  <section data-testid="workflows-section" className="relative py-24 md:py-32 bg-[var(--surface-2)]">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-[0.8fr_1.2fr] gap-14">
      <div className="lg:sticky lg:top-32 self-start">
        <Reveal>
          <Eyebrow>Recommended workflows</Eyebrow>
          <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.02]">Seven paths from question to evidence.</h2>
          <p className="mt-6 text-[var(--muted)] leading-relaxed">From a single deposited structure to a multi-family evidence package — each path keeps archived measurements separate from fresh comparisons.</p>
        </Reveal>
      </div>
      <div>
        {WORKFLOWS.map((w, i) => (
          <Reveal key={w.k} delay={0.04}>
            <div data-testid={`workflow-${w.k.toLowerCase()}`} className="group border-t border-[var(--line)] py-8 last:border-b">
              <div className="flex items-baseline gap-5">
                <span className="font-display text-4xl font-extrabold text-outline group-hover:text-[var(--teal)] transition-colors">{w.k}</span>
                <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight">{w.t}</h3>
              </div>
              <div className="mt-5 flex flex-wrap items-center gap-2 pl-0 sm:pl-12">
                {w.steps.map((s, j) => (
                  <span key={s} className="flex items-center gap-2">
                    <span className="rounded border border-[var(--line)] bg-[var(--surface)] px-3 py-1 text-xs sm:text-sm text-[var(--muted)] group-hover:border-[#1f7a6c]/40 transition-colors">{s}</span>
                    {j < w.steps.length - 1 && <span className="text-[var(--teal)] text-xs">→</span>}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
